<template>
    <div class="text-center">
        <v-dialog v-model="showDialog" width="500">
            <v-card>
                <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                    {{ $translate("INVALID_CART") }}
                </v-card-title>
                <v-card-text class="pt-6">
                    {{ errorMessage }}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="handleOkClick">
                        {{ $translate('Ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    name: "InvalidCartDialog",
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        onOkClick: {
            type: Function,
            default: null,
        },
    },
    data: () => ({
        showDialog: false,
    }),
    watch: {
        value(val) {
            this.showDialog = val;
        },
        showDialog(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        handleOkClick() {
            this.showDialog = false;
            if (this.onOkClick) {
                this.onOkClick();
            }
        },
    },
    computed: {
        errorMessage() {
            return this.$translate("CART_INVALID_LEGAL_ENTITY").format(this.$store.state.invalidCartDialog.cartLegalEntityName, this.$store.state.invalidCartDialog.conflictingLegalEntityName);
        }
    }
};
</script>
